
import apiConfig from '@/config/api.config'
import { sampleBySeed, stockFirst } from '@/unit/recommend'
import { fetchPublicConfig } from '@/utils/publicConfig'
export default {
  name: 'Hot',
  data () {
    return {
      isDisplay: false, // 返回顶部按钮显现（滚过 320px）
      sectionProducts: [],
      showTierBadge: true, // "惠/靓/正"角标全局开关（public config 下发；默认显示）
      recommendedProducts: [],
      recSeed: 0, // 更多推荐本次浏览的随机种子（同次稳定，重进变化）
      BATCH_SIZE: 12, // 瀑布流循环每批追加量（首轮首批同此，触底 +N）
      loading: false,
      loadingMore: false,
      pageBanner: null,
      isDragging: false,
      hasMoved: false,
      dragStartX: 0,
      dragStartY: 0,
      btnX: 0,
      btnY: 0
    }
  },
  created () {
    // 本次浏览的随机种子：组件重建（keepAlive:false）时换新值 → 重新进入顺序/集合变化
    this.recSeed = (Math.random() * 1e9) | 0
    this.fetchPageBanner()
    // 先取顶部运营位，再拉推荐池并去重（避免与顶部商品重复展示）
    this.fetchSectionProducts().then(() => this.fetchRecommended())
    // "惠/靓/正"角标全局开关（默认 true，显式 false 才隐藏）
    fetchPublicConfig().then(cfg => { this.showTierBadge = cfg.showHuiliangzhengBadge !== false })
  },
  mounted () {
    // 提前续页：sentinel 进入"距底部约 1.2 视口"预载区即追加下一批（本地池循环，不发请求）。
    // rootMargin bottom 120% = 视口下沿再扩 1.2×vh，sentinel 尚未真正入屏就触发，用户感知不到页面底部。
    this._sentinelObserver = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) this.ensurePrefill()
    }, { root: null, rootMargin: '0px 0px 120% 0px', threshold: 0 })
    this.$nextTick(() => {
      const el = this.$refs.infiniteSentinel
      if (el) this._sentinelObserver.observe(el)
    })
    // scroll 冗余驱动：IO 为主，scroll 事件同口径兜底（快速 fling 下更实时；判定/锁在 ensurePrefill 内统一）
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    if (this._sentinelObserver) this._sentinelObserver.disconnect()
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    isAdmin () { return this.$store.getters.isAdmin }
  },
  methods: {
    async fetchPageBanner () {
      try {
        const res = await this.axios.get('config/page-banner', { params: { type: 'hot' } })
        if (res.data.code === 200 && res.data.data) {
          this.pageBanner = res.data.data
        }
      } catch (e) {}
    },
    handleBannerClick () {
      if (this.pageBanner?.banner_url) {
        if (this.pageBanner.banner_url.startsWith('http')) {
          window.open(this.pageBanner.banner_url, '_blank')
        } else {
          this.$router.push(this.pageBanner.banner_url)
        }
      }
    },
    async fetchSectionProducts () {
      if (this.loading) return
      this.loading = true
      try {
        const idRes = await this.axios.get('config/page-products', { params: { page: 'hot' } })
        if (idRes.data.code === 200 && idRes.data.data && idRes.data.data.length > 0) {
          const ids = idRes.data.data
          const res = await this.axios.get(apiConfig.apiList.getProducts, { params: { ids: ids.slice(0, 50).join(',') } })
          if (res.data.code === 200) {
            const map = {}
            res.data.data.forEach(p => { map[p.id] = p })
            this.sectionProducts = ids.map(id => map[id]).filter(p => p)
          }
        }
      } catch (err) {
        console.error('获取热销商品失败:', err)
      } finally {
        this.loading = false
      }
    },
    async fetchRecommended () {
      try {
        const res = await this.axios.get('products/recommend-pool', { params: { type: 'hot', size: 60 } })
        if (res.data.code === 200) {
          const pool = res.data.data || []
          const topIds = new Set(this.sectionProducts.map(p => p.id)) // 去重：排除顶部运营位商品
          this._recPool = pool.filter(p => !topIds.has(p.id))         // 全量池（实例属性，不进 data）
          if (this._recPool.length === 0) return
          // 首次全长洗牌（displayCount=池长 → 返回全长序列）；后续触底从该序列 slice 追加，全程不请求后端。
          // stockFirst 分层：有货随机段在前、无货段沉底（池序=权重信号在层内保留）
          this._round = 0
          this._shuffledPool = stockFirst(this._recPool, sub => sampleBySeed(sub, this.recSeed, sub.length))
          this._poolIndex = 0
          this.recommendedProducts = []
          this.loadMoreRecommend()
        }
      } catch (err) {
        console.error('获取推荐商品失败:', err)
      }
    },
    // 客户端循环：从已缓存的 _shuffledPool 序列分批追加，不请求后端；池末换 seed 重洗（顺序变，非固定重复）
    loadMoreRecommend () {
      if (this.loadingMore || this.loading) return
      if (!this._recPool || this._recPool.length === 0) return
      this.loadingMore = true
      setTimeout(() => {
        if (this._poolIndex >= this._shuffledPool.length) {
          this._round = (this._round || 0) + 1
          this.recSeed = (this.recSeed + 2654435761) >>> 0 // 黄金比例步进，解耦相邻 seed
          this._shuffledPool = stockFirst(this._recPool, sub => sampleBySeed(sub, this.recSeed, sub.length))
          this._poolIndex = 0
        }
        const batch = this._shuffledPool.slice(this._poolIndex, this._poolIndex + this.BATCH_SIZE)
          .map(p => ({ ...p, _round: this._round })) // 注入轮次，供 :key 区分第二轮起的重复商品
        this.recommendedProducts = [...this.recommendedProducts, ...batch]
        this._poolIndex += batch.length
        this.loadingMore = false
        // 批量落 DOM 后复测预载：首屏/PC 大屏内容不足时 sentinel 仍在预载区，IO 无新回调，靠链补足
        this.$nextTick(() => this.ensurePrefill())
      }, 300)
    },
    // 预载判定：sentinel 顶边 < 2.2×vh（视口高 + 1.2×vh 提前量，与 rootMargin 120% 同一数值口径）。
    // loadingMore 即现有互斥锁——一次触发一批；池空由 loadMoreRecommend 头部短路断链。
    ensurePrefill () {
      if (this.loadingMore || this.loading) return
      const el = this.$refs.infiniteSentinel
      if (!el) return
      const rect = el.getBoundingClientRect()
      const vh = window.innerHeight || document.documentElement.clientHeight
      if (rect.top < vh * 2.2) this.loadMoreRecommend()
    },
    handleScroll () {
      // 返回顶部按钮：滚过 320px 显现（与 Home/详情页同阈值）
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isDisplay = scrollTop > 320
      // 仅续页兜底驱动，无节流：ensurePrefill 同步快（一次 rect 读 + 锁判断），scroll 事件本身帧级节流
      this.ensurePrefill()
    },
    // 返回顶部（与 Home/详情页同款：滚回 0 并立即收按钮）
    goBackTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.isDisplay = false
    },
    onBackClick () {
      if (this.hasMoved) return
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/home')
      }
    },
    startDrag (e) {
      this.isDragging = true
      this.hasMoved = false
      const touch = e.touches ? e.touches[0] : e
      this.dragStartX = touch.clientX
      this.dragStartY = touch.clientY
      const btn = this.$refs.backBtn
      const rect = btn.getBoundingClientRect()
      this.btnX = rect.left
      this.btnY = rect.top
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.endDrag)
      document.addEventListener('touchmove', this.onDrag, { passive: false })
      document.addEventListener('touchend', this.endDrag)
    },
    onDrag (e) {
      if (!this.isDragging) return
      e.preventDefault()
      const touch = e.touches ? e.touches[0] : e
      const dx = touch.clientX - this.dragStartX
      const dy = touch.clientY - this.dragStartY
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) this.hasMoved = true
      const btn = this.$refs.backBtn
      btn.style.left = (this.btnX + dx) + 'px'
      btn.style.top = (this.btnY + dy) + 'px'
      btn.style.right = 'auto'
      btn.style.bottom = 'auto'
    },
    endDrag () {
      if (!this.isDragging) return
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.endDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.endDrag)
      const btn = this.$refs.backBtn
      const rect = btn.getBoundingClientRect()
      const winW = window.innerWidth
      const margin = 10
      const btnW = 44
      const distLeft = rect.left
      const distRight = winW - rect.right
      btn.style.transition = 'all 0.3s ease'
      if (distLeft <= distRight) {
        btn.style.left = margin + 'px'
      } else {
        btn.style.left = (winW - margin - btnW) + 'px'
      }
      btn.style.right = 'auto'
      btn.style.bottom = 'auto'
      setTimeout(() => { btn.style.transition = '' }, 300)
    },
    toDetails (id) {
      this.$router.push({ path: '/details', query: { id } })
    }
  }
}
